// Collection page: collections/<key>.html (key comes from <body data-c>)
(function () {
  const e = LC.escape;
  let key = LC.param('c') || 'all';
  if (!LC.collections[key]) key = 'all';
  const col = LC.collections[key];
  const seo = LC.collectionSeo[key] || { h1: col.name, title: `${col.name} | Le Chic Beauty`, meta: col.description, intro: col.description };
  const products = LC.inCollection(key);
  const heroImg = LC.collectionImage(key);
  const path = LC.collectionUrl(key);

  // Signature collection this page belongs to (itself, or the parent of a sub-collection)
  const parent = LC.subcollections[key] ? key
    : Object.keys(LC.subcollections).find((g) => LC.subcollections[g].includes(key));

  const pill = (k, active, label) =>
    `<a class="tab${active ? ' is-active' : ''}" href="${LC.collectionUrl(k)}"${active ? ' aria-current="page"' : ''}>${e(label || LC.collections[k].name)}</a>`;

  const topPills = ['all', ...LC.collectionOrder]
    .map((k) => pill(k, k === key || (k === parent && key !== parent)))
    .join('');

  const subPills = parent
    ? `<nav class="col-subpills" aria-label="${e(LC.collections[parent].name)} categories">
        ${[parent, ...LC.subcollections[parent]].map((k) => pill(k, k === key, k === parent ? `All ${LC.collections[parent].name}` : null)).join('')}
      </nav>`
    : '';

  const crumbItems = [['Home', 'index.html']];
  if (parent && parent !== key) crumbItems.push([LC.collections[parent].name, LC.collectionUrl(parent)]);
  crumbItems.push([col.name, path]);

  /* ---------- Collection FAQs, computed from catalog facts ---------- */
  const nouns = {
    all: 'products', tools: 'hair tools', care: 'hair care products', 'flat-irons': 'flat irons',
    'blow-dryers': 'blow dryers and blow dryer brushes', curling: 'curling wands and curlers', travel: 'travel hair tools',
    'hair-care': 'Repairing Caviar products', treatments: 'hair treatments', extensions: 'hair extensions',
    accessories: 'hair accessories', grooming: 'grooming products'
  };
  const noun = nouns[key] || col.name.toLowerCase();
  const list = (arr) => (arr.length <= 1 ? arr.join('') : `${arr.slice(0, -1).join(', ')} and ${arr[arr.length - 1]}`);
  const names = (arr) => arr.map((p) => p.name);
  const having = (re) => products.filter((p) => p.features.some((f) => re.test(f)) || p.highlights.some((h) => re.test(h.title)));
  const toolKeys = ['all', 'tools', 'flat-irons', 'blow-dryers', 'curling', 'travel'];

  const faqs = [];
  if (products.length) {
    faqs.push({ q: `What ${noun} does Le Chic Beauty offer?`, a: `Le Chic Beauty offers ${products.length} ${noun}: ${list(names(products))}.` });
  }
  const priced = products.filter((p) => p.price != null);
  if (priced.length) {
    const prices = priced.map((p) => p.price);
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    const soon = products.filter((p) => p.price == null);
    faqs.push({
      q: `How much do Le Chic Beauty ${noun} cost?`,
      a: `${min === max ? `Le Chic Beauty ${noun} are ${LC.formatPrice(min)}.` : `Le Chic Beauty ${noun} range from ${LC.formatPrice(min)} to ${LC.formatPrice(max)}.`}${soon.length ? ` Pricing for ${list(names(soon))} is coming soon.` : ''}`
    });
  }
  if (toolKeys.includes(key)) {
    const infrared = having(/infrared/i);
    if (infrared.length) {
      faqs.push({ q: `Which Le Chic Beauty ${noun} use infrared heat?`, a: `${list(names(infrared))} ${infrared.length > 1 ? 'use' : 'uses'} far infrared heat, which provides gentler, more even heat distribution that helps style hair from the inside out while enhancing shine and smoothness.` });
    }
    const ionic = having(/negative ion|ionic/i);
    if (ionic.length) {
      faqs.push({ q: `Which Le Chic Beauty ${noun} have negative ion technology?`, a: `${list(names(ionic))} ${ionic.length > 1 ? 'feature' : 'features'} negative ion technology, which helps reduce frizz, tame flyaways and leave hair sleek, smooth and glossy.` });
    }
    const dual = having(/dual voltage/i);
    if (dual.length) {
      faqs.push({ q: `Which Le Chic Beauty ${noun} are dual voltage?`, a: `${list(names(dual))} ${dual.length > 1 ? 'are' : 'is'} dual voltage for international travel. Depending on your destination, you may need a plug adapter.` });
    }
    if (key !== 'all') {
      faqs.push({ q: `Do Le Chic Beauty ${noun} come with a warranty?`, a: `Yes. Le Chic Beauty ${noun} purchased from Le Chic Beauty or an authorized retailer are covered by a Limited Lifetime Warranty when registered within 14 days of purchase.` });
    }
  }
  if (['care', 'hair-care'].includes(key)) {
    const sulfateFree = having(/sulfate/i);
    if (sulfateFree.length) faqs.push({ q: 'Is Le Chic Beauty Repairing Caviar shampoo sulfate-free?', a: `Yes. ${list(names(sulfateFree))} ${sulfateFree.length > 1 ? 'are' : 'is'} sulfate- and paraben-free.` });
    faqs.push({ q: 'What is in the Le Chic Beauty Repairing Caviar collection?', a: 'The Repairing Caviar collection is a four-step ritual: Repairing Caviar Shampoo to cleanse, Repairing Caviar Conditioner to condition, Repairing Caviar Hair Mask as a weekly treatment and Repairing Caviar Hair Serum to finish, made with caviar extract, keratin and argan oil.' });
  }
  if (key === 'extensions') {
    const P = LC.storeFaqs();
    faqs.push({ q: 'What is the difference between halo and clip-in hair extensions?', a: 'Halo extensions are one piece on a fitted wire that rests beneath your own hair, applied in minutes with no glue, clips or heat. Clip-in extensions are individual wefts you clip in section by section for flexible placement. Le Chic Beauty halo extensions come in 14–16" and 16–18"; clip-ins come in 18" and 22".' });
    faqs.push({ q: P.remy[0], a: `${P.remy[1]}.` });
    faqs.push({ q: 'How many shades do Le Chic Beauty hair extensions come in?', a: 'Le Chic Beauty hair extensions come in 28 shades, from #1 Black to #70 White Blonde, including dimensional blends such as #4/27 and #18/24.' });
    faqs.push({ q: P.haloLast[0], a: `${P.haloLast[1]}.` });
  }
  faqs.push({ q: `How fast does Le Chic Beauty ship ${noun}?`, a: 'Le Chic Beauty typically ships orders within 1–2 business days of purchase, with tracking. You may cancel the same day your order is placed, before it ships. Once shipped, orders cannot be cancelled.' });

  document.getElementById('collection-main').innerHTML = `
    <nav class="breadcrumb container" aria-label="Breadcrumb"><ol>${crumbItems.map(([n, u], i) => (i === crumbItems.length - 1 ? `<li aria-current="page">${e(n)}</li>` : `<li><a href="${u}">${e(n)}</a></li>`)).join('')}</ol></nav>

    <section class="container col-hero">
      <div class="col-hero-copy">
        <p class="chip">${key === 'all' ? 'The Collection' : e(col.eyebrow || col.name)}</p>
        <h1>${e(seo.h1)}</h1>
        <p class="col-tagline">${e(col.tagline)}</p>
        <p>${e(seo.intro)}</p>
      </div>
      <div class="col-hero-media${heroImg.lifestyle ? '' : ' is-product'}"><img src="${e(heroImg.src)}" alt="${e(heroImg.alt)}" width="1000" height="1000"></div>
    </section>

    <section class="container col-shop" aria-label="${e(col.name)} products">
      <div class="col-toolbar">
        <div class="col-nav">
          <nav class="col-pills" aria-label="Collections">${topPills}</nav>
          ${subPills}
        </div>
        <div class="col-sort">
          <span id="col-count">${products.length} product${products.length === 1 ? '' : 's'}</span>
          <label for="col-sort-select" class="sr-only">Sort products</label>
          <select id="col-sort-select">
            <option value="featured">Featured</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
            <option value="name">Name: A–Z</option>
          </select>
        </div>
      </div>
      <div class="product-grid" id="col-grid">${products.map(LC.cardHTML).join('')}</div>
    </section>

    ${faqs.length ? `
      <section class="section faq2" id="faq" aria-labelledby="col-faq-title">
        <div class="container faq2-grid">
          <div class="faq2-aside">
            <p class="chip">Good to Know</p>
            <h2 id="col-faq-title">${e(col.name)} FAQ</h2>
            <p>Quick answers about Le Chic Beauty ${e(noun)}. Still deciding? <a href="pages/contact.html">Ask Le Chic Beauty Customer Care</a>.</p>
          </div>
          <div class="faq2-list">
            ${faqs.map((f, i) => `<details${i === 0 ? ' open' : ''}><summary>${e(f.q)}</summary><p>${e(f.a)}</p></details>`).join('')}
          </div>
        </div>
      </section>` : ''}`;

  /* ---------- SEO ---------- */
  LC.seo({
    title: seo.title,
    description: seo.meta,
    path,
    image: heroImg.src,
    imageAlt: heroImg.alt,
    jsonld: [
      LC.webPageLd('CollectionPage', path, seo.title, seo.intro, {
        breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` },
        mainEntity: { '@id': `${LC.abs(path)}#products` }
      }),
      Object.assign(LC.breadcrumbLd(crumbItems), { '@id': `${LC.abs(path)}#breadcrumb` }),
      LC.itemListLd(products, path, seo.h1),
      LC.faqLd(faqs, path)
    ]
  });

  /* ---------- Sorting ---------- */
  const grid = document.getElementById('col-grid');
  const sortSelect = document.getElementById('col-sort-select');
  const priceOr = (p, fallback) => (p.price == null ? fallback : p.price);
  const sorters = {
    featured: () => 0,
    'price-asc': (a, b) => priceOr(a, Number.MAX_VALUE) - priceOr(b, Number.MAX_VALUE),
    'price-desc': (a, b) => priceOr(b, -1) - priceOr(a, -1),
    name: (a, b) => a.name.localeCompare(b.name)
  };
  sortSelect.addEventListener('change', () => {
    grid.innerHTML = products.slice().sort(sorters[sortSelect.value]).map(LC.cardHTML).join('');
  });
})();
